import type { DisplayProduct, ProductClickHandler } from '../../types';
import { ProductCard } from './components/ProductCard/ProductCard';
import styles from './ProductGrid.module.css';

interface ProductGridProps {
  products: DisplayProduct[];
  /** Drop the grid's own max-width/padding when it's nested inside a laid-out container. */
  flush?: boolean;
  onProductClick?: ProductClickHandler;
}

export function ProductGrid({ products, flush = false, onProductClick }: ProductGridProps) {
  return (
    <div className={`${styles.grid} ${flush ? styles.flush : ''}`}>
      {products.map((product) => (
        <ProductCard key={product.code} product={product} onProductClick={onProductClick} />
      ))}
    </div>
  );
}
